import React from 'react';
export function TransicionSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-145">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-146">
        <div className="space-y-4 text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-147">
          <p data-id="element-148">Este mapa te dará claridad.</p>
          <br data-id="element-149" />
          <p data-id="element-150">
            Pero el siguiente paso es diseñar tu negocio alrededor del 20% que
            realmente genera crecimiento.
          </p>
          <br data-id="element-151" />
          <p data-id="element-152">Eso es lo que trabajamos en:</p>
        </div>

        <div className="mt-12 inline-block" data-id="element-153">
          <span className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#1B2A4A] to-[#FF6B00] tracking-tight" data-id="element-154">
            Juega desde Otro Nivel
          </span>
        </div>
      </div>
    </section>;
}